import { render, staticRenderFns } from "./RaceEdit.vue?vue&type=template&id=5a6b76a1&"
import script from "./RaceEdit.vue?vue&type=script&lang=js&"
export * from "./RaceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports